<template>
  <div
    class="spinner-wheel-winner-popup _container animate__bounceIn animate__animated"
    :class="{ '--dark': isTextColourLight }"
    :style="{}"
    @click="closeWinnerPopup"
  >
    <div class="spinner-wheel-winner-popup_container">
      <div class="spinner-wheel-winner-popup _close-icon">
        <aha-icon
          name="close"
          viewBox="0 0 24 24"
        />
      </div>
      <div class="spinner-wheel-winner-popup _winner-name">
        {{ $t('The result is…') }}
      </div>
      <spinner-wheel-label
        class="transform scale-150 rounded-lg _popup"
        :background-color="backgroundColor"
        :text="text"
        :variant="variant"
      />

      <aha-antd-button
        v-if="isShowRemoveEntry"
        class="btn-remove-winner-entry"
        @click="removeWinnerEntry"
        v-tooltip="$t('Remove this entry for the next spin')"
        variant="tertiary"
        icon-name="trash-new"
        icon-classes="h-5 w-5"
      >
        {{ $t('Remove entry') }}
      </aha-antd-button>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Util from '@/util'
import SpinnerWheelLabel from './SpinnerWheelLabel.vue'

export default {
  components: {
    SpinnerWheelLabel,
  },
  props: {
    closeShowWinner: {
      type: Function,
      default: () => null,
    },
    text: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      firework: null,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      sharePresentation: (state) => state.sharePresentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    ...mapGetters(['isBackstage', 'isTextColourLight']),
    isShowRemoveEntry() {
      return !this.isBackstage
        && !this.sharePresentation
        && !this.isDisableEditPresentation
    },
  },
  mounted() {
    this.firework = Util.firework()
    const labelEl = this.$el.querySelector('.spinner-wheel-label._container')
    if (labelEl) {
      const rgb = labelEl.style.backgroundColor // vue will convert whatever color into rgb ;)
      labelEl.style.boxShadow = `0px 14px 28px ${rgb.replace(')', ', 0.3)')}`
    }
  },
  destroyed() {
    if (this.firework) this.firework.stopFirework()
  },
  methods: {
    closeWinnerPopup() {
      if (this.closeShowWinner) this.closeShowWinner()
      if (this.firework) this.firework.stopFirework()
    },
    removeWinnerEntry() {
      this.$emit('remove-winner-entry')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.spinner-wheel-winner-popup {
  color: #313131;

  &._container {
    width: 1280px;
    background-color: rgba(255, 255, 255, 0.95);
    z-index: $highest-z-index - 2; // high z-index, but lower than firework's canvas
    @apply fixed top-0 right-0 h-full;
    @apply flex items-center justify-center flex-col;
  }

  .spinner-wheel-winner-popup_container{
    position: absolute;
    width: 556px;
    height: 274px;
    left: 361px;
    top: 230.17px;
    background: #FFFFFF;
    box-shadow: 0px 8px 14px rgb(82 95 127 / 13%);
    border-radius: 12px;
    ._winner-name{
      display: block;
      margin-top: 50px;
      margin-bottom: 12px;
      padding: 10px 0;
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 33px;
      align-items: center;
      text-align: center;
    }
    .spinner-wheel-label._container._popup{
      max-width: 312px;
      margin: 0 auto;
    }
    .btn-remove-winner-entry{
      font-size: 18px;
      margin-top: 54px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &.--dark {
    background-color: rgba(0, 0, 0, 0.8);
  }

  &._winner-name {
    font-size: 20px;
    line-height: 20px;
    @apply mb-6 font-bold;
  }

  &._close-icon {
    @apply cursor-pointer absolute right-4 top-4 text-base-70;
    @apply p-2 hover:text-primary-90;

    @media (max-width: 768px) {
      top: 4rem;
      right: 3rem;
    }
  }
}
</style>
